export default {
    modal: {
        header: {
            text: "Detalles de la Cuenta",
            waivedInterestPromotion: "Promoción de Intereses Eximidos",
        },
        footer: {
            closeButton: "Cerrar",
            backButton: "ATRÁS",
        },
    },
    drawerHeader: {
        title: "Cuenta de SetPay",
        subtitle: {
            account: "Cuenta que termina en {{accountLast4}}",
            loan: "Préstamo que termina en {{accountLast4}}",
        },
    },
    grid: {
        month: "mes",
        months: "meses",
        meter: "Saldado",
        creditMeter: "Crédito Utilizado",
        meterPN4: "Pagos Realizados",
        loanAmount: "Monto del Préstamo",
        amountFinanced: "Monto Financiado",
        loanMaturityDate: "Fecha de vencimiento del préstamo",
        totalLoanBalance: "Saldo Total del Préstamo",
        totalDue: "Total Adeudado",
        totalLoanBalanceTooltip: "El Saldo Total del Préstamo puede cambiar por varias razones (por ej. cargos, tarifas, pagos y devoluciones). Si corresponde, el Saldo Total del Préstamo puede aumentar a medida que se cumplen los pedidos.",
        securedInstallmentTotalLoanBalanceTooltip: "Este es el saldo del capital restante que aún se adeuda por su préstamo. No es el monto requerido para pagar el préstamo en su totalidad. Para obtener una cotización actual para la liquidación llame a nuestro equipo de Atención al Cliente en <helpNumber/>.",
        totalDueTooltip: "Incluye toda tarifa y todo monto vencido anterior.",
        autopayStatusTooltip: "Para administrar la configuración de su pago automático, llame al <helpNumber/>.",
        purchaseAmount: "Monto de Compra",
        totalRemaining: "Saldo Restante",
        totalPaid: "Total Pagado",
        creditLimit: "Límite de Crédito",
        currentBalance: "Saldo Actual",
        statementBalance: "Saldo del Estado de Cuenta",
        availableToSpend: "Disponible para Gastar",
        availableToSpendTooltip: "Podría no reflejar transacciones recientes.",
        promotionStatusTooltip: {
            active: "Este préstamo está dentro del período promocional de Exención de Interés.",
            expired: "Este préstamo está fuera del período promocional de Exención de Interés y ya no es elegible para que todos los intereses sean eximidos.",
        },
        titles: {
            accountInformation: "Información de la Cuenta",
            payments: "Pagos",
            paymentInformation: "Información de Pagos",
            loanSummary: "Resumen del Préstamo",
            loanDetails: "Detalles del Préstamo",
            loanInformation: "Información del Préstamo",
            paymentSchedule: "Cronograma de pagos",
        },
        labels: {
            feesChargedYearToDate: "Total de las Comisiones Cobradas a la Fecha en este Año (YTD)",
            interestChargedYearToDate: "Total de Intereses Cobrados a la Fecha en este Año (YTD)",
            purchaseAPR: "Tasa de Porcentaje Anual (APR) para Compras",
            cashAdvanceLimit: "Límite para Adelantos en Efectivo",
            cashAdvanceAPR: "Tasa de Porcentaje Anual para Adelantos en Efectivo",
            currentBalance: "Saldo Actual",
            lastStatementBalance: "Último Saldo del Estado de Cuenta",
            newPurchases: "Nuevas Compras",
            nextPaymentDate: "Próxima fecha de vencimiento del pago",
            totalMinimumPaymentDue: "Pago Mínimo Total Adeudado",
            lastPaymentDate: "Última Fecha de Pago",
            lastPaymentAmount: "Último monto de Pago",
            outstandingFeesAndCharges: "Tarifas y Cargos Pendientes",
            pastDueAmount: "Monto vencido",
            currentInterestRate: "Tasa de Interés Actual",
            autoPayStatus: {
                on: "Encendido",
                off: "Apagado",
                text: "Estatus de Autopay",
            },
            principalPaid: "Principal Pagado",
            interestPaid: "Interés Pagado",
            activeIntroRateLoanInformationTooltip: "Su préstamo tiene una tasa de introducción con un pago fijo. Su tasa y monto de pago aumentarán cuando finalice el período de introducción.",
            expiredIntroRateLoanInformationTooltip: "El periodo de introducción con tasa y pago fijo de su préstamo ha finalizado. La tasa de interés y el monto de su pago aumentaron al concluir dicho periodo.",
            introRateLoanMonthlyPayment: "Período de Tasa de Introducción de {{promoLoanTerm}} Meses",
            postIntroLoanMonthlyPayment: "Período de Tasa Posterior a la Introducción de {{postLoanTerm}} Meses",
            introPeriodRate: "Tasa del Período de Introducción",
            introPeriodExpirationDate: "Fecha de Finalización del Período de Introducción",
            introPeriodStatus: "Estatus del Período de Introducción",
            postIntroRate: "Tasa Posterior a la Introducción",
            purchaseAmount: "Monto de Compra",
            purchaseDate: "Fecha de Compra",
            monthlyLoanPayment: "Pago Mensual del Préstamo",
            monthlyPayment: "Pago Mensual",
            loanAmount: "Monto del Préstamo",
            loanStartDate: "Fecha del Comienzo del Préstamo",
            loanEndDate: "Fecha de Terminación del Préstamo",
            promotionalPeriodEnds: "Finalización del Período Promocional",
            introPeriodEnds: "El Período de Introducción Termina",
            introPeriodEnded: "Terminó el Período de Introducción",
            promotionalPeriod: "Periodo Promocional",
            interestRate: "Tasa de Interés",
            loanTerm: "Términos del Préstamo",
            termRemaining: "Término Restante",
            estimatedPayoffAmount: "Estimado del Monto de liquidación",
            estimatedPayoffAmountTooltip: "El valor estimado del monto de liquidación es válido solo por el día de hoy.",
            activePromoStatusTooltip: "Este préstamo está dentro del período de introducción. Usted tiene una tasa más baja.",
            expiredPromoStatusTooltip: "El período de introducción se ha vencido. Su tasa se ha incrementado.",
            scheduledLoanPayment: "Pago del Préstamo Programado",
            nextAmountDue: "Próximo Monto Adeudado",
            nextAmountMothlyTooltip: "Incluye toda tarifa y todo monto vencido anterior.",
            nextAmountPN4Tooltip: "Incluye todo el monto vencido anteriormente.",
            paymentNumberOfTotal: "Pago {{n, number}} de {{total, number}}",
            paymentAmount: "Monto de Pago",
            scheduledPaymentAmount: "Monto del Pago Programado",
            nextScheduledPaymentAmount: "Monto del Próximo Pago Programado",
            nextScheduledPaymentDate: "Próxima Fecha de Pago Programado",
            promoExpirationDate: "Fecha de Vencimiento de la Promoción",
            promotionalBalance: "Saldo Promocional",
            promotionStatus: {
                active: "Activa",
                expired: "Vencida",
                text: "Estatus de la Promoción",
            },
        },
        accountNotice: "Es posible que los montos no reflejen la actividad reciente.",
        accountNoticePN4: "Los Montos y la fecha de terminación  podrían no reflejar la actividad reciente.",
        accountNoticeSecuredInstallmentLoan: "Este es un intento de cobrar una deuda y toda información que se obtenga se utilizará para este propósito.",
    },
    error: {
        api: {
            title: "Detalles de la Cuenta no Disponibles",
        },
        default: {
            title: "¡Lo sentimos, ocurrió un problema inesperado!",
            subtitle: "Tenemos problemas para recuperar esta información. Por favor, vuelva a cargar la página o vuelva a intentar más tarde.",
        },
        uiComponent: "No Disponible",
    },
    waivedInterest: {
        days: "días",
        heading: "¿Qué es un préstamo en cuotas con exención de intereses?",
        bold: {
            first: " todo el interés es eximido si lo paga en su totalidad antes del final del período promocional.",
            second: " No hay penalizaciones por pago adelantado. ",
        },
        first: "Es un préstamo en cuotas con exención de intereses si se paga en su totalidad dentro del período promocional,",
        second: "Es un préstamo para un solo uso que finaliza cuando se paga en su totalidad. El préstamo tiene una APR (Tasa de Porcentaje Anual) fija, un plazo fijo y pagos mensuales.",
        third: "Si usted liquida su monto financiado además de cualquier tarifa impuesta antes del final del período promocional, todos los intereses serán eximidos.",
        fourth: "Si usted no paga el monto financiado más cualquier tarifa impuesta antes del final del plazo del período promocional, se cargará interés hasta por todo el plazo del préstamo.",
        promoEndDate: "Liquide el saldo de su préstamo incluyendo las tarifas a la fecha del {{promoEndDate}} para la exención del interés.",
        expiredPromoEndDate: "Este préstamo está fuera del período promocional de Exención de Interés.",
    },
    introRateLoan: {
        activeIntroLoanDetails: "Consejo: Haga un pago de liquidación o pague más durante su período de introducción para reducir el interés pagado a lo largo del préstamo.",
        expiredIntroLoanDetails: "Su tasa de introducción ha terminado.",
        introStatusActive: "Activa",
        introStatusExpired: "Vencida",
    },
    sandbox: {
        dashboard: {
            viewDetails: "Ver Detalles",
            accountEndingIn: "Cuenta que termina en",
            loanEndingIn: "Préstamo que termina en",
        },
    },
};
//# sourceMappingURL=es.js.map